// Delegate click on every <a/> tag instead of attaching individual listeners to avoid performance issues:
document.body.addEventListener("click", (e) => {
  // Support <a/> tags with child elements
  let target = e.target.tagName === "A" ? e.target : event.target.closest("a");

  // Make sure we have a valid target, with href attribute.
  if (target && target.hasAttribute("href")) {
    let currentHref = target.getAttribute("href");

    // Get current domain to compare with link destination
    let currentDomain = window.location.hostname;
    
    // Check if the link points to the same domain
    let pointsToSameDomain = false;
    
    try {
      if (currentHref.startsWith("/") || currentHref.startsWith("#")) {
        // Relative paths and anchors are always same domain
        pointsToSameDomain = true;
      } else if (currentHref.startsWith("http")) {
        // For absolute URLs, extract the hostname and compare
        let linkUrl = new URL(currentHref);
        pointsToSameDomain = linkUrl.hostname === currentDomain;
      } else if (!currentHref.includes("://")) {
        // Relative URLs without leading slash are also same domain
        pointsToSameDomain = true;
      }
    } catch (error) {
      // If URL parsing fails, treat as external link for safety
      pointsToSameDomain = false;
    }

    // Detect downloads links hosted at current domain or to an absolute path
    let isDownloadsLocationAnyFile =
      currentHref.startsWith("/static/downloads/") &&
      currentHref.lastIndexOf(".");
    let isPDF = currentHref.lastIndexOf(".pdf") > -1;

    // Check if href starts with #
    let startsWithHash = currentHref.startsWith("#");

    if (isDownloadsLocationAnyFile || isPDF) {
      target.setAttribute("download", "");
    }

    // Add target="_blank" only for external links (different domain)
    if (!pointsToSameDomain && !startsWithHash) {
      target.setAttribute("target", "_blank");
    }

    if (startsWithHash) {
      e.preventDefault();
      // Scroll to the target anchor
      let targetElement = document.querySelector(currentHref);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  }
});
